import { FC } from 'react';
import {
  CenterContent,
  CenteredScreenLayout,
  EmptyCenterLeft,
  EmptyCenterRight,
  EmptyFooter,
  EmptyHeader,
  StructuredText,
} from '../../Components/CenteredScreenLayout';
import { SYM } from '@resistdesign/voltra/app/components';

export type InterviewCompleteProps = {};

export const InterviewComplete: FC<InterviewCompleteProps> = () => {
  return (
    <CenteredScreenLayout>
      <EmptyHeader />
      <EmptyCenterLeft />
      <CenterContent>
        <article>
          <StructuredText>
            <SYM
              style={{
                fontSize: '2em',
                verticalAlign: 'middle',
                color: 'green',
              }}
            >
              verified
            </SYM>{' '}
            Thank you for participating, your interview is now complete.
          </StructuredText>
        </article>
      </CenterContent>
      <EmptyCenterRight />
      <EmptyFooter />
    </CenteredScreenLayout>
  );
};
